'use client'

import { replaceTemplatePlaceholders } from "@/util/replaceTemplateText";

interface EmbedVariabletTextProps {
  heading: string;
  treatmentName: string;
  cityName:string;
}

const EmbedVariableTextComponent = ({ heading, treatmentName, cityName }: EmbedVariabletTextProps) => {
  const text = replaceTemplatePlaceholders(heading, treatmentName,cityName);
  return <>{text}</>;
};

export default EmbedVariableTextComponent;

